var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_442)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 7.5V74C7.5 76.7842 8.606 79.4547 10.5747 81.4253C12.5453 83.394 15.2158 84.5 18 84.5H53C54.932 84.5 56.5 86.068 56.5 88C56.5 89.932 54.932 91.5 53 91.5C53 91.5 32.4812 91.5 18 91.5C13.359 91.5 8.907 89.6555 5.62575 86.3742C2.3445 83.093 0.5 78.641 0.5 74V4C0.5 2.06625 2.06625 0.5 4 0.5H74C75.9338 0.5 77.5 2.06625 77.5 4V88C77.5 89.9338 75.9338 91.5 74 91.5H67C65.068 91.5 63.5 89.932 63.5 88C63.5 86.068 65.068 84.5 67 84.5H70.5V7.5H7.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5 25H60C61.932 25 63.5 23.432 63.5 21.5C63.5 19.568 61.932 18 60 18H56.5C54.568 18 53 19.568 53 21.5C53 23.432 54.568 25 56.5 25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5 39H60C61.932 39 63.5 37.432 63.5 35.5C63.5 33.568 61.932 32 60 32H56.5C54.568 32 53 33.568 53 35.5C53 37.432 54.568 39 56.5 39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 60H60C61.932 60 63.5 58.432 63.5 56.5C63.5 54.568 61.932 53 60 53H18C16.068 53 14.5 54.568 14.5 56.5C14.5 58.432 16.068 60 18 60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 74H60C61.932 74 63.5 72.432 63.5 70.5C63.5 68.568 61.932 67 60 67H18C16.068 67 14.5 68.568 14.5 70.5C14.5 72.432 16.068 74 18 74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 18C46 16.0662 44.4338 14.5 42.5 14.5H18C16.0662 14.5 14.5 16.0662 14.5 18V39C14.5 40.9338 16.0662 42.5 18 42.5H42.5C44.4338 42.5 46 40.9338 46 39V18ZM21.5 21.5V35.5H39V21.5H21.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74 14.5C72.0662 14.5 70.5 16.0662 70.5 18V88H74V91.5C83.6652 91.5 91.5 83.6652 91.5 74V18C91.5 16.0662 89.9338 14.5 88 14.5H74ZM84.5 21.5H77.5V83.9015C81.5775 82.4613 84.5 78.5727 84.5 74V21.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNews);
export default __webpack_public_path__ + "static/media/icon_news.dc92eae9b1129c4af8bb02508605daae.svg";
export { ForwardRef as ReactComponent };